

const webcontent = () =>{
    return (
        
                      <div className="container mt-4">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="saptitle erptitle">What is ProMan?</div>
                <p className="erppara"> 
                ProMan – A SAAS(Software-as-a-Service) model production management ERP, is a comprehensive production management software that integrates various core processes and functions within manufacturing organization into a single system.
                </p>
                <ul className="websub erpul">
	<li className="webpoints">It allows for streamlined data flow and facilitates efficient communication between departments. </li>
    <li className="webpoints">Any organization that acquire the ProMan service doesn’t need to invest much on the infrastructure.</li>
                </ul>
                
                    </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <img src="https://www.testscenario.com/wp-content/uploads/2022/09/what-is-Saas-testing.png" alt="erp" className="img-erp img-shadow" />
                </div>
            </div>
        </div>
 
        
    )
}

export default webcontent